import React from 'react';
import ReactDatePicker from 'react-datepicker';
import './DatePicker.scss';

import 'react-datepicker/dist/react-datepicker.css';

interface Props {
  id?: string;
  containerClassName?: string;
  className?: string;
  onChange: (
    date: Date | [Date, Date] | null,
    event: React.SyntheticEvent<any, Event> | undefined
  ) => void;
  onFocus?: any;
  onBlur?: any;
  value?: Date;
  label: string;
  labelClassName?: string;
  wrapperClassName?: string;
  disabled?: boolean;
  calendarClassName?: string;
  maxDate?: Date;
  minDate?: Date;
  openToDate?: Date;
  onCalendarOpen?: () => void;
  onCalendarClose?: () => void;
  onChangeRaw?: (event?: React.SyntheticEvent<any, Event>) => void;
}

const defaultProps = {
  value: undefined,
  id: '',
  className: '',
  autoComplete: 'off',
};

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

const DatePicker = ({
  id,
  containerClassName,
  labelClassName,
  onChange,
  value,
  label,
  className,
  disabled,
  onFocus,
  onBlur,
  calendarClassName,
  maxDate,
  minDate,
  openToDate,
  onCalendarOpen,
  onCalendarClose,
  onChangeRaw,
}: Props) => {
  return (
    <div className={containerClassName}>
      <label className={labelClassName} htmlFor={label}>
        {label}
      </label>
      <ReactDatePicker
        id={id}
        selected={value}
        onChange={onChange}
        className={className}
        dateFormat={DEFAULT_DATE_FORMAT}
        dropdownMode="select"
        showIcon={!disabled}
        isClearable={!disabled}
        readOnly={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        icon="icon fas fa-calendar-alt"
        calendarIconClassname={calendarClassName}
        autoComplete="off"
        minDate={minDate}
        maxDate={maxDate}
        openToDate={openToDate}
        onCalendarClose={onCalendarClose}
        onCalendarOpen={onCalendarOpen}
        onChangeRaw={onChangeRaw}
      />
    </div>
  );
};

DatePicker.defaultProps = defaultProps;

export default DatePicker;
